export function e164ToFrench(phone: string) {
  // Remove the +33 and keep only digits
  const clean = phone.replace(/^\+33/, "0");

  // Add a space every 2 digits
  return clean.replace(/(\d{2})(?=\d)/g, "$1 ").trim();
}

export function fillPhoneInput(
  phone: string,
  input?: HTMLInputElement | null | undefined
) {
  let inputToFill = input;

  if (!input) {
    inputToFill = document.querySelector(
      'input[type="tel"]'
    ) as HTMLInputElement;
  }

  if (inputToFill) {
    inputToFill.value = phone;
    inputToFill.dispatchEvent(new Event("input", { bubbles: true }));
  }
}

const testPhoneNumberPrefix = "+3363998";

export function newTestPhoneNumber(): string {
  // This prefix is provided by ARCEP for testing purpose.
  return (
    testPhoneNumberPrefix +
    String(randomPhoneNumberDigit()) +
    String(randomPhoneNumberDigit()) +
    String(randomPhoneNumberDigit()) +
    String(randomPhoneNumberDigit())
  );
}

export function isTestPhoneNumber(phone: string): boolean {
  return phone.startsWith(testPhoneNumberPrefix);
}

function randomPhoneNumberDigit(): number {
  return randomIntFromInterval(0, 9);
}

// min and max included
function randomIntFromInterval(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min);
}
